import { ArrowLeft } from 'lucide-react';
import React from 'react';
import BetSettings from './BetSettings';
import ConfigDisplay from './ConfigDisplay';
import ControlPanel from './ControlPanel';
import ReelEditor from './ReelEditor';
import SimulationResults from './SimulationResults';
import SlotIconsEditor from './SlotIconEditor';
import WinScalesEditor from './WinScalesEditor';

const SimulationPage = ({
  setCurrentPage,
  betBody,
  setBetBody,
  presets,
  savePreset,
  loadPreset,
  deletePreset,
  exportConfig,
  importConfig,
  resetToDefaults,
  simulateBet,
  loading,
  errors,
  results,
  authTokens,
  getStepStatus,
}) => {
  const getStepIcon = (step) => {
    const status = getStepStatus(step);
    if (status === 'loading') return <div className="w-4 h-4 bg-blue-500 rounded-full animate-pulse"></div>;
    if (status === 'success') return <div className="w-4 h-4 bg-green-500 rounded-full"></div>;
    if (status === 'error') return <div className="w-4 h-4 bg-red-500 rounded-full"></div>;
    return <div className="w-4 h-4 bg-gray-300 rounded-full"></div>;
  };

  return (
    <div className="max-w-6xl p-6 mx-auto bg-white rounded-lg shadow-lg">
      <div className="mb-8">
        <div className="flex items-center gap-4 mb-4">
          <button
            onClick={() => setCurrentPage('auth')}
            className="flex items-center gap-1 px-3 py-1 text-sm font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Назад до авторизації
          </button>
        </div>
        <h1 className="mb-2 text-3xl font-bold text-gray-900">Betting Simulator - Симуляція ставок</h1>
        <p className="text-gray-600">Крок 2: Конфігурація та запуск симуляції ставок</p>
      </div>

      <ControlPanel
        presets={presets}
        savePreset={savePreset}
        loadPreset={loadPreset}
        deletePreset={deletePreset}
        exportConfig={exportConfig}
        importConfig={importConfig}
        resetToDefaults={resetToDefaults}
        errors={errors}
      />

      <div className="grid grid-cols-1 gap-6 mb-6 xl:grid-cols-2">
        <WinScalesEditor betBody={betBody} setBetBody={setBetBody} />

        <div className="space-y-6">
          <BetSettings betBody={betBody} setBetBody={setBetBody} />
        </div>
      </div>

      <div className="mb-6">
        <div className="col-span-2 p-4 rounded-lg bg-gray-50">
          <h3 className="mb-4 text-lg font-semibold text-gray-900">Reel Sets Configuration</h3>
          <div className="space-y-6">
            {betBody.config.reelSets
              .filter((reelSet) => {
                return !reelSet.id.includes('SLOT_REEL') && !reelSet.id.includes('BONUS');
              })
              .map((reelSet) => (
                <ReelEditor
                  key={reelSet.id}
                  reelSet={reelSet}
                  onUpdate={(updatedReelSet) => {
                    const originalIndex = betBody.config.reelSets.findIndex((rs) => rs.id === reelSet.id);
                    const newReelSets = [...betBody.config.reelSets];
                    newReelSets[originalIndex] = updatedReelSet;
                    setBetBody((prev) => ({
                      ...prev,
                      config: {
                        ...prev.config,
                        reelSets: newReelSets,
                      },
                    }));
                  }}
                  symbols={[
                    'A',
                    'B',
                    'C',
                    'D',
                    'E',
                    'F',
                    'G',
                    'H',
                    'HP',
                    'LP',
                    'WL',
                    'ML',
                    'SE',
                    'SE1',
                    'SE2',
                    'SC1',
                    'SC2',
                  ]}
                />
              ))}
          </div>
        </div>
      </div>

      <SlotIconsEditor
        slotIcons={betBody.config.slotIcons}
        slotId={betBody.config.slot.id}
        onUpdate={(updatedSlotIcons) => {
          setBetBody((prev) => ({
            ...prev,
            config: {
              ...prev.config,
              slotIcons: updatedSlotIcons,
            },
          }));
        }}
      />

      <SimulationResults
        simulateBet={simulateBet}
        loading={loading}
        errors={errors}
        results={results}
        authTokens={authTokens}
        getStepIcon={getStepIcon}
      />

      <ConfigDisplay betBody={betBody} />
    </div>
  );
};

export default SimulationPage;
